import { render, staticRenderFns } from "./tipoanimal.vue?vue&type=template&id=23ebefa8"
import script from "./tipoanimal.vue?vue&type=script&lang=js"
export * from "./tipoanimal.vue?vue&type=script&lang=js"
import style0 from "./tipoanimal.vue?vue&type=style&index=0&id=23ebefa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports